import React, { MouseEventHandler, useCallback, useRef } from "react"
import { useParams } from "react-router"

import { useAccount, useLayerPopupContext } from "@shared/contexts"
import { open as popupOpen } from "@shared/modules"
import { Params } from "@shared/types"

import { useSetIsSidebarEnabled } from "live/contexts"

import LinkItem from "./LinkItem"

const WAITTING_CHAT_MODE = 1000 * 1

interface Props {
  title: string
}

const WindowMode = ({ title }: Props) => {
  const { scheduleId, streamerName } = useParams<Params>()
  const handleSidebar = useSetIsSidebarEnabled()
  const { open } = useLayerPopupContext()
  const { account } = useAccount()

  const chattingWindow = useRef<Window | null>(null)

  const isAnonymous = account?.viewer?.role === "ANONYMOUS"

  const handleWindowMode: MouseEventHandler<HTMLAnchorElement> = useCallback(
    (e) => {
      e.preventDefault()
      if (isAnonymous) return open("ANONYMOUS")

      chattingWindow.current = popupOpen(
        `/${streamerName}/${scheduleId}/chat-mode`,
        "chatMode",
        "width=500px,height=757px,menubar=no,location=no,resizable=yes",
      )

      setTimeout(() => {
        chattingWindow.current!.onbeforeunload = function () {
          if (!chattingWindow.current?.closed) {
            handleSidebar.open()
          }
        }

        window.onbeforeunload = function () {
          chattingWindow.current!.close()
        }
      }, WAITTING_CHAT_MODE)

      handleSidebar.close()
    },
    [streamerName, scheduleId, handleSidebar, open, isAnonymous],
  )

  return <LinkItem className="ty04" title={title} onClick={handleWindowMode} />
}

export default WindowMode
